
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/property-services",
      function () {
        return require("private-next-pages/property-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/property-services"])
      });
    }
  